import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange} from "@angular/core";
import {ClassificationField} from "../../../../../../../models/classification-field";
import {Guide} from "../../../../../../../models/guide";
import {ClassificationControllerService} from "../../../../../../../services/classifications-controller/classification-controller.service";

@Component({
  selector: "field-set-default",
  templateUrl: "./field-set-default.component.html",
  styles: [],
})
export class FieldSetDefaultComponent implements OnChanges {

  @Input() public fieldOptions: any;
  @Input() public classificationFields: ClassificationField[] = [];
  @Input() public guide: Guide;
  @Input() public groupId: string;
  @Output() public dataChanged = new EventEmitter();

  constructor(private classificationControllerService: ClassificationControllerService) {

  }

  public ngOnChanges(_changes: { [propKey: string]: SimpleChange }) {
    if (_changes.groupId && _changes.groupId.currentValue) {
      this.groupId = _changes.groupId.currentValue;
    }
    if (this.guide.classification && this.fieldOptions.inputType === "classification") {
      this.loadCatalogueFields(this.guide.classification.id);
    }
  }

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

  public loadCatalogueFields(id: any) {
    if (this.guide.catalogGroupId) {
      this.classificationControllerService.getClassificationFieldByGroupId(this.guide.catalogGroupId).subscribe(
          (data) => this.classificationFields = data,
      );
    } else {
      this.classificationControllerService.getClassificationsByType(id).subscribe(
          (data) => this.classificationFields = data,
      );
    }
  }
}
